import styled from 'styled-components';

export const UploadFeedbackWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  right: 12px;
  z-index: 9999;
`;

export const MyWorkspaceContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: auto;
`;

export const FiltersRow = styled.div`
  height: 80px;
  background: #ffffff;
  display: flex;
  align-items: center;
  
  h3 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  align-items: center;
  background: #ffffff;
  > div {
    width: 100%;
  }

  
`;

export const CardViewXContainer = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;

  /* 2 columns for small screens (S) */
  grid-template-columns: repeat(2, 1fr);

  /* 4 columns for medium and large screens (M and L) */
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* 5 columns for extra large screens (XL) */
  @media (min-width: 1920px) {
    grid-template-columns: repeat(5, 1fr);
  }
  & > div > div > div > div:nth-child(2) > div.dots-menu > button{
    padding: 0 8px;
  }
`;

export const FolderCardWrapper = styled.div`
  cursor: pointer;
  user-select: none; /* Prevent text selection on double click */
`;